import { memo } from "react";
import ReactPlayer from "react-player";

const VideoPlayer = memo(
  ({
    url,
    width = "100%",
    height = "360px",
    controls = true,
    onError = null,
  }) => (
    <div className="App" style={{ width, height, background: "#000" }}>
      <ReactPlayer
        url={url}
        controls={controls}
        width="100%"
        height="100%"
        config={{
          youtube: {
            playerVars: {
              fs: 1,
              rel: 0,
              modestbranding: 1,
            },
          },
        }}
        onError={onError}
      />
    </div>
  ),
);

VideoPlayer.displayName = "VideoPlayer";

export default VideoPlayer;
